import React from 'react';

const Skeleton = () => {
  return (
    <div className="tw-bg-card tw-border tw-border-border tw-rounded-lg tw-shadow-sm tw-mb-4 tw-animate-pulse">
      <div className="tw-p-4 tw-border-b tw-flex tw-items-center tw-space-x-4">
        <div className="tw-h-10 tw-w-10 tw-rounded-full tw-bg-muted"></div>
        <div className="tw-space-y-2">
          <div className="tw-h-4 tw-w-32 tw-bg-muted tw-rounded"></div>
          <div className="tw-h-3 tw-w-24 tw-bg-muted tw-rounded"></div>
        </div>
      </div>
      <div className="tw-p-4 tw-space-y-4">
        <div className="tw-flex tw-justify-between tw-items-center">
          <div className="tw-h-4 tw-w-24 tw-bg-muted tw-rounded"></div>
          <div className="tw-h-4 tw-w-24 tw-bg-muted tw-rounded"></div>
          <div className="tw-h-4 tw-w-24 tw-bg-muted tw-rounded"></div>
          <div className="tw-h-4 tw-w-24 tw-bg-muted tw-rounded"></div>
        </div>
        <div className="tw-space-y-2">
          <div className="tw-h-12 tw-w-full tw-bg-muted tw-rounded"></div>
          <div className="tw-h-12 tw-w-full tw-bg-muted tw-rounded"></div>
          <div className="tw-h-12 tw-w-full tw-bg-muted tw-rounded"></div>
        </div>
      </div>
    </div>
  );
};

export default Skeleton;
